import { render, staticRenderFns } from "./CategoryPage.vue?vue&type=template&id=f413673c&scoped=true&lang=pug&"
import script from "./CategoryPage.vue?vue&type=script&lang=js&"
export * from "./CategoryPage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPage.vue?vue&type=style&index=0&id=f413673c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f413673c",
  null
  
)

export default component.exports